const inline = (text, keyBase) => text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => (
  part.startsWith("**") && part.endsWith("**")
    ? <strong key={`${keyBase}-${i}`} className="text-[#1B2A4A] font-semibold">{part.slice(2, -2)}</strong>
    : part
));

export const readingTime = (content = "") => Math.max(2, Math.round(content.split(/\s+/).length / 200));

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "");

export default function ArticleBody({ content = "" }) {
  const blocks = content.replace(/\r/g, "").split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  return (
    <div data-testid="article-body" className="space-y-5 text-[#334155] text-base sm:text-[17px] leading-relaxed">
      {blocks.map((b, i) => {
        if (b.startsWith("### ")) return <h3 key={i} className="pt-2 font-display text-xl text-[#1B2A4A]">{b.slice(4)}</h3>;
        if (b.startsWith("## ")) return <h2 key={i} className="pt-6 font-display text-2xl sm:text-3xl text-[#1B2A4A] tracking-tight">{b.slice(3)}</h2>;
        const lines = b.split("\n");
        if (lines.every((l) => l.trim().startsWith("- "))) {
          return (
            <ul key={i} className="space-y-2.5">
              {lines.map((l, j) => <li key={j} className="flex gap-3"><span className="mt-2.5 w-1.5 h-1.5 bg-[#E0C173] shrink-0" />{<span>{inline(l.trim().slice(2), `${i}-${j}`)}</span>}</li>)}
            </ul>
          );
        }
        return <p key={i}>{inline(b.replace(/\n/g, " "), i)}</p>;
      })}
    </div>
  );
}
